
export function isValidQuotationCode(code: string | undefined): boolean {
  if (!code) return false;
  
  // Basic validation - code should be a non-empty string
  if (typeof code !== 'string' || code.trim() === '') {
    return false;
  }
  
  // Additional validation rules can be added here
  // For example, if codes follow a specific format like "QT-XXXXX"
  // return /^QT-\d{5}$/.test(code);
  
  return true;
}

export function generateQuotationShareUrl(code: string): string {
  // Create an absolute URL for sharing
  const baseUrl = window.location.origin;
  return `${baseUrl}/quotation/${code}`;
}

// Alias for backward compatibility
export function generateQuotationUrl(code: string): string {
  return generateQuotationShareUrl(code);
}

export function formatQuotationDate(dateString: string | null | undefined): string {
  if (!dateString) return '—';
  
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
}

export function getQuotationStatusColor(status: string | undefined): string {
  switch (status?.toLowerCase()) {
    case 'pending':
      return 'bg-yellow-500';
    case 'accepted':
      return 'bg-green-500';
    case 'rejected':
      return 'bg-red-500';
    case 'expired':
      return 'bg-gray-500';
    default:
      return 'bg-blue-500';
  }
}

// Format a phone number to be compatible with WhatsApp's API
export function formatWhatsAppNumber(phone: string): string {
  // Remove any non-digit characters
  const digits = phone.replace(/\D/g, '');
  
  // Check if the number already has the country code
  if (digits.startsWith('55') && digits.length >= 12) {
    return digits;
  }
  
  // Add Brazil's country code (55) if missing
  return `55${digits}`;
}

// Create a WhatsApp message with quotation details
export function generateQuotationMessage(customerName: string, url: string): string {
  return encodeURIComponent(
    `Olá ${customerName}, aqui está o orçamento da Solucionar Soldas: ${url}`
  );
}

// Open WhatsApp with a pre-filled message
export function openWhatsApp(phone: string, message: string): boolean {
  try {
    const whatsappUrl = `https://wa.me/${phone}?text=${message}`;
    window.open(whatsappUrl, '_blank');
    return true;
  } catch (error) {
    console.error('Error opening WhatsApp:', error);
    return false;
  }
}
